/**
 * useDemoMode — Hook fuer reaktiven Demo-Modus-Zustand (W3.1)
 *
 * Wraps die demoMode-Service-Funktionen mit React-State
 * damit Komponenten auf Demo-Modus-Aenderungen reagieren koennen.
 */
import { useState, useCallback } from 'react'
import { isDemoMode, activateDemo, deactivateDemo } from '../services/demoMode'

export function useDemoMode() {
  const [demo, setDemo] = useState(isDemoMode())

  // Gibt false zurueck, wenn kein Demo-Token konfiguriert ist (Modus bleibt aus).
  const activate = useCallback((): boolean => {
    const activated = activateDemo()
    if (activated) setDemo(true)
    return activated
  }, [])

  const deactivate = useCallback(() => {
    deactivateDemo()
    setDemo(false)
  }, [])

  return { isDemoMode: demo, activate, deactivate }
}
